import {IState} from '../../../core/IState';
import {UnauthorizedController} from '../controllers/unauthorizedController';

export const UnauthorizedState: IState = {
    name: 'unauthorized',
    url: '/unauthorized/{message}',
    template: require('../templates/unauthorized.html'),
    controller: UnauthorizedController,
    controllerAs: 'vm',
    data: {
        title: 'Unauthorized'
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/unauthorized/states/unauthorizedState.ts
 **/